<template>
  <div class="language-switch">
    <Dropdown trigger="click" :placement="placement" @on-click="switchLanguage" transfer>
      <slot name="trigger" :currentLangText="currentLangText">
        <a href="javascript:void(0)" :style="{ color: color }">
          {{ currentLangText }}
          <Icon type="ios-arrow-down"></Icon>
        </a>
      </slot>
      <template #list>
        <DropdownMenu>
          <DropdownItem v-for="(item, key) in languageList" :key="key" :name="key">{{ item }}</DropdownItem>
        </DropdownMenu>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { setLanguage } from '../../lang/i18n'

export default {
  props: {
    color: {
      type: String,
      default: '#2d8cf0'
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },
  data () {
    return {
      // 顺序与 Flutter language_select_page._languages 一致；简中、繁中相邻
      languageList: {
        'zh-cn': '简体中文',
        'zh-tw': '繁體中文',
        'en-us': 'English',
        'ko-kr': '한국어',
        'de-de': 'Deutsch',
        'nl-nl': 'Nederlands',
        'pt-br': 'Português (Brasil)',
        'fr-fr': 'Français',
        'ru-ru': 'Русский',
        'it-it': 'Italiano',
        'es-es': 'Español',
        'pl-pl': 'Polski',
        'sv-se': 'Svenska',
        'vi-vn': 'Tiếng Việt'
      }
    }
  },
  computed: {
    currentLanguage () {
      return this.$i18n.locale
    },
    currentLangText () {
      return this.languageList[this.currentLanguage] || this.languageList['zh-cn'] || '简体中文'
    }
  },
  methods: {
    switchLanguage (lang) {
      // 刷新页面以应用语言变化
      if (setLanguage(lang)) {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped>
.language-switch {
  display: inline-block;
  margin-right: 10px;
}

.language-switch-text {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/LanguageSwitch.vue